<section class="mode-demploi-page" aria-label="Mode d'emploi">
  <h1>Mode d'emploi</h1>
</section>